import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase credentials not found. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file."
  );
}

// Create client with optional custom Authorization header.
// For external JWTs (Portale Operatori), we bypass supabase.auth.setSession()
// and inject the token directly into PostgREST requests via global headers.
function createSupabaseClient(token?: string | null) {
  return createClient(
    supabaseUrl || "https://placeholder.supabase.co",
    supabaseAnonKey || "placeholder-key",
    token
      ? {
          global: {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        }
      : undefined
  );
}

export let supabase = createSupabaseClient();

// Update the Supabase client with a new external JWT (Portale Operatori token).
// Recreates the client so all subsequent PostgREST calls use the new token.
export function updateSupabaseAuth(token: string | null) {
  supabase = createSupabaseClient(token);
}
